import type { FilterRule } from '@/lib/tableFilters/filterRuleTypes';

export const FILTER_PRESETS_STORAGE_KEY = 'project-table-filter-presets';

export const READERS_CATALOG_FILTER_PRESETS_STORAGE_KEY = 'readers-catalog-filter-presets';

export interface FilterPreset {
  id: string;
  name: string;
  filters: Record<string, FilterRule>;
  createdAt: number;
}

export function loadFilterPresets(storageKey: string = FILTER_PRESETS_STORAGE_KEY): FilterPreset[] {
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (p): p is FilterPreset =>
        p != null &&
        typeof p === 'object' &&
        typeof (p as FilterPreset).id === 'string' &&
        typeof (p as FilterPreset).name === 'string' &&
        typeof (p as FilterPreset).createdAt === 'number' &&
        (p as FilterPreset).filters != null &&
        typeof (p as FilterPreset).filters === 'object'
    );
  } catch {
    return [];
  }
}

export function saveFilterPresets(
  presets: FilterPreset[],
  storageKey: string = FILTER_PRESETS_STORAGE_KEY
): void {
  try {
    localStorage.setItem(storageKey, JSON.stringify(presets));
  } catch {
    /* ignore */
  }
}
